export default __webpack_public_path__ + "static/media/stonks.5cf0b925.svg";